<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        از تاریخ</label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :min="fromDateMin" :max="fromDateMax" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :max="toDateMax" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
            </div>
            <div class="row" style="display: flex; justify-content: end">
                 <div v-if="isSearched" class="col-md-3">
                     <button class="btn btn-warning btn-block" @click="getExelPath">
                         دریافت فایل اکسل
                     </button>
                 </div>
                <div class="col-md-3">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>شماره کارت</th>
                        <th>مبلغ</th>
                        <th>زمان</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ row.cardNumber }}</td>
                        <td>{{ row.amount ? new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(row.amount) : '0'}} ریال</td>
                        <td>{{ row.chargeDateShamsi.replace(/\//g,'').slice(0,4) + '/' + row.persianDate.replace(/\//g,'').slice(4,6) + '/' + row.persianDate.replace(/\//g,'').slice(6,8) }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="(page , index) in pages" :key="index">
                            <div style="display: flex; flex-direction: row;" >
                                <span class="page-link ml-1" v-if="page > pages[index-1] + 1 " > ... </span>
                                <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                            </div>
                        </li> 
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'CardCharge',
    data(){
        return {
            showLoading: false,
            isSearched: false,
            rows: [],
            fromDate: '',
            toDateMax :moment().format('jYYYY-jMM-jDD'),
            fromDateMax :moment().format('jYYYY-jMM-jDD'),
            fromDateMin :"",
            toDate: '',
            currentPage: 1,
            pages: [1],
            perPage: 10,
            count: 0,
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        },
        fromDate(value){
            let toDateMax = moment(value ,'jYYYY-jMM-jDD' ).add(29, 'days');
            if(toDateMax < moment())  this.toDateMax = toDateMax.format('jYYYY-jMM-jDD');
            if(moment(this.toDate , 'jYYYY-jMM-jDD' ) > toDateMax) this.toDate = "";
        },
        toDate(value){
            let fromDateMin = moment(value ,'jYYYY-jMM-jDD' ).add(-29, 'days');
            this.fromDateMax = value;
            this.fromDateMin = fromDateMin.format('jYYYY-jMM-jDD');
            if(moment(this.fromDate , 'jYYYY-jMM-jDD' ) < fromDateMin) this.fromDate = "";
        },
    },
    methods: {
        handlePaginateArray(pagesCount){
            let pagesArray = [1];
            if(pagesCount > 1){
               if(this.currentPage > 2) pagesArray.push(this.currentPage -1)
               if(this.currentPage > 1)  pagesArray.push(this.currentPage)
               if(this.currentPage < pagesCount) pagesArray.push(this.currentPage +1)
               const middle =  Math.ceil(pagesCount/ 2)
               if(middle >  this.currentPage +1  && middle < pagesCount-2){
                    pagesArray.push(middle)
               }
                if(this.currentPage < pagesCount) pagesArray.push(pagesCount)
                

            }
            this.pages = pagesArray;
        },
        getExelPath(){
            this.showLoading = true;
            const postedData = {
                from: this.fromDate.replace(/\//g,''),
                to: this.toDate.replace(/\//g,''),
                page: this.currentPage,
                perPage: this.perPage,
            };
            this.$api.post('charge/GetChargeHistoryExcelReport',postedData).then(({data}) => {
                if(data.status){
                    let a = window.document.createElement('a');
                    a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result.fileName);
                    let fileName = data.result.filename;
                    a.setAttribute('download',fileName);
                    window.document.body.appendChild(a);
                    a.click();
                    window.document.body.removeChild(a);
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        getData(){
            this.showLoading = true;
            const postedData = {
                from: this.fromDate.replace(/\//g,''),
                to: this.toDate.replace(/\//g,''),
                page: this.currentPage,
                perPage: this.perPage,
            };
            this.$api.post('charge/GetChargeHistory',postedData).then(({data}) => {
                if(data.status){
                    this.rows = data.result.list;
                    this.count = data.result.totalCount;
                    this.isSearched = true;
                    this.showLoading = false;
                    let calcPages = Math.ceil((data.result.totalCount) / this.perPage);
                    this.handlePaginateArray(calcPages);
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        submit(){
            this.getData();
        },
    },
}
</script>